import { render, staticRenderFns } from "./metadataDialog.vue?vue&type=template&id=277ecac7&"
import script from "./metadataDialog.vue?vue&type=script&lang=js&"
export * from "./metadataDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports